import React, { useEffect } from 'react';
import heroimg from '../../Assets/heroimg.png'
import heroimgmble from '../../Assets/aboutpgheroinimg.png'
import sparkle from '../../Assets/sparkle.png'
import xpat from '../../Assets/xpaticon.png'
import kolab from '../../Assets/kolab.png'
import integrit from '../../Assets/integrit.png'
import imgteam from '../../Assets/Imageteam.png'
import imgteammble from '../../Assets/ourteammble.png'
import x from '../../Assets/x.png'
import linkedin from '../../Assets/linkedin.png'
import classes from './Aboutus.module.css';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import Getstarted from '../../Components/Get started/Getstarted'
import { useLocation } from 'react-router-dom';


const Aboutus = () => {

  useEffect(() => {
    window.scrollTo(0, 0);


    // IntersectionObserver to handle scroll animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add a delay before applying the visible class
            setTimeout(() => {
              entry.target.classList.add(classes.visible);
              entry.target.classList.remove(classes.hidden); // Remove hidden class
            }, 200); // Adjust delay as needed (300ms here)
            observer.unobserve(entry.target); // Stop observing once visible
          }
        });
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    // Select all elements with the 'hidden' class
    const hiddenElements = document.querySelectorAll(`.${classes.hidden}`);
    hiddenElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect(); // Cleanup observer on component unmount
  }, []);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  return (
    <>
      <Navigation />
      <div className={classes.aboutus}>

        <section className={`${classes.aboutushero} ${classes.hidden}`}>
          <div className={classes.aboutusherotxt}>
            <div className={classes.herotxtshii}>
              <p className={classes.herotxt}>Who We Are - <span>Your Partner in Digital Excellence</span></p>
            </div>
            <div className={classes.herotxt2}>
              <p>We handle your non-core functions so you can focus on what matters most. From custom software development to branding, marketing, and business support.</p>
            </div>
          </div>
          <div>
            <img src={heroimg} className={`${classes.heroimg} ${classes.hidden}`} alt="About Us" />
            <img src={heroimgmble} className={`${classes.heroimgmble} ${classes.hidden}`} alt="About Us" />
          </div>
        </section>

        <section className={`${classes.aboutuscontent} ${classes.hidden}`}>
          <div className={classes.aboutuscontenttxt}>
            <h1 className={classes.hlpbiztxt}>Helping Businesses Go Global with Smart Digital Solutions</h1>
            <p className={classes.lilbittxt}>ScaleWorkflow was founded with a simple mission: to help businesses thrive by handling their non-core functions. With a team of skilled professionals, we provide end-to-end solutions that drive growth and innovation</p>
            <div className={classes.ylwgys} >
              <div>
                <p className={classes.fitypls}>50+</p>
                <p className={classes.fityplstxt}>Projects</p>
              </div>
              < div className={classes.andastyl} />
              <div >
                <p className={`${classes.fitypls} ${classes.andasmtyl}`}>100+</p>
                <p className={classes.fityplstxt}>Clients</p>
              </div>
            </div>
          </div>
          <div className={classes.aboutuscontentimg}>
            <img src={sparkle} className={`${classes.sparkle} ${classes.hidden}`} alt="About Us" />
          </div>
        </section>

        <section className={`${classes.corevaluesshii} ${classes.hidden}`}>
          <div>
            <p className={`${classes.corevaltxt} ${classes.hidden}`}>Our Core Values</p>
            <div className={`${classes.corevalueswhole} ${classes.hidden}`}>
              <div className={`${classes.corevalues} ${classes.hidden}`}>
                <img src={xpat} className={`${classes.xpaticon} ${classes.hidden}`} alt="xpertise" />
                <p className={classes.xpatise}>Epertise</p>
                <p className={classes.xpatiseliltxt}>We're passionate about what we do and constantly strive to improve</p>
              </div>
              <div className={`${classes.corevalues1} ${classes.hidden}`}>
                <img src={kolab} className={`${classes.xpaticon} ${classes.hidden}`} alt="xpertise" />
                <p className={classes.xpatise}>Collaboration</p>
                <p className={classes.xpatiseliltxt}>We're passionate about what we do and constantly strive to improve</p>
              </div>
              <div className={`${classes.corevalues2} ${classes.hidden}`}>
                <img src={integrit} className={`${classes.xpaticon} ${classes.hidden}`} alt="xpertise" />
                <p className={classes.xpatise}>Integrity</p>
                <p className={classes.xpatiseliltxt}>We're passionate about what we do and constantly strive to improve</p>
              </div>
            </div>
          </div>
        </section>

        {/* Meet the team begins here */}

        {/* <section className={`${classes.ourteam} ${classes.hidden}`}>
        <p className={classes.meettheteam}>Meet the Team</p>
        <div className={classes.ourteamwhole}>
          <div>
            <div>
              <img src={imgteam} className={classes.imgteam} alt="About Us" />
              <img src={imgteammble} className={classes.imgteammble} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={classes.ourteamimg} alt="x icon" />
                <img src={linkedin} className={classes.ourteamimg} alt="linkedin icon" />
              </div>
            </div>
          </div>
          <div>
            <div>
              <img src={imgteam} className={`${classes.imgteam} ${classes.hidden}`} alt="About Us" />
              <img src={imgteammble} className={`${classes.imgteammble} ${classes.hidden}`} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={`${classes.ourteamimg} ${classes.hidden}`} alt="x icon" />
                <img src={linkedin} className={`${classes.ourteamimg} ${classes.hidden}`} alt="linkedin icon" />
              </div>
            </div>
          </div>
          <div>
            <div>
              <img src={imgteam} className={classes.imgteam} alt="About Us" />
              <img src={imgteammble} className={classes.imgteammble} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={classes.ourteamimg} alt="x icon" />
                <img src={linkedin} className={classes.ourteamimg} alt="linkedin icon" />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.ourteamwhole}>
          <div>
            <div>
              <img src={imgteam} className={classes.imgteam} alt="About Us" />
              <img src={imgteammble} className={classes.imgteammble} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={classes.ourteamimg} alt="x icon" />
                <img src={linkedin} className={classes.ourteamimg} alt="linkedin icon" />
              </div>
            </div>
          </div>
          <div>
            <div>
              <img src={imgteam} className={classes.imgteam} alt="About Us" />
              <img src={imgteammble} className={classes.imgteammble} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={classes.ourteamimg} alt="x icon" />
                <img src={linkedin} className={classes.ourteamimg} alt="linkedin icon" />
              </div>
            </div>
          </div>
          <div>
            <div>
              <img src={imgteam} className={classes.imgteam} alt="About Us" />
              <img src={imgteammble} className={classes.imgteammble} alt="About Us" />
            </div>
            <div className={classes.ourteamtxt}>
              <div>
                <p className={classes.ourteamtxt1}>Olivia Rhye</p>
                <p className={classes.ourteamtxt2}>Founder & CEO</p>
              </div>
              <div className={classes.ourteamicons}>
                <img src={x} className={classes.ourteamimg} alt="x icon" />
                <img src={linkedin} className={classes.ourteamimg} alt="linkedin icon" />
              </div>
            </div>
          </div>
        </div>
      </section> */}

        {/* Meet the team ends here */}

        <Getstarted />


      </div>
      <Footer />
    </>
  );
};

export default Aboutus;
